import { makeStyles } from "@mui/styles";

export const MessageSectionStyle = makeStyles(({ theme }) => ({}));
